/* ag-v86.js - AquaGrip CT (v86, 27 Oct 2026, Claude). Loaded after ag-v85.js.
   1. Phone menu (Dawn header-drawer): white, full width. Search bar on top,
      a New Arrival card (Dog Bowl Mat), the studios as a 2-column photo grid,
      then the store's own menu (still edited in Navigation), then Cart /
      Account and the social links. The header's own search + cart icons are
      hidden on phones (CSS); they live in here now.
   2. Desktop mega menu: white panel. The photo card on the right defaults to
      the New Arrival (Dog Bowl Mat) and still follows the link you point at;
      a full-width row of studio photos runs along the bottom.
   Data: #agMenuData (snippets/ag-nautical.liquid) - product photos, cart
   count, search/cart/account routes, social links from theme settings. */
(function(){
  'use strict';
  if(window.__agv86) return; window.__agv86 = true;

  var D = {};
  try{ D = JSON.parse(document.getElementById('agMenuData').textContent) || {}; }catch(e){}
  var items = D.items || [];
  var dog = null, studios = [];
  items.forEach(function(it){ if(/dog/.test(it.key)) dog = it; else studios.push(it); });

  var P = {
    search: '<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.6-3.6"/>',
    cart: '<path d="M3 4h2l2.2 11.2a2 2 0 0 0 2 1.6h7.6a2 2 0 0 0 2-1.5L21 8H6.2"/><circle cx="10" cy="20.5" r="1.2"/><circle cx="17" cy="20.5" r="1.2"/>',
    user: '<circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.6-6 8-6s6.5 2 8 6"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    fb: '<path d="M14 8h3V4h-3a4 4 0 0 0-4 4v3H7v4h3v7h4v-7h3l1-4h-4V8.5a.5.5 0 0 1 .5-.5z"/>',
    ig: '<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".8"/>'
  };
  function ico(k, fill){ return '<svg viewBox="0 0 24 24" aria-hidden="true" fill="' + (fill ? 'currentColor' : 'none') + '" stroke="' + (fill ? 'none' : 'currentColor') + '" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + P[k] + '</svg>'; }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function img(src, alt){ return src ? '<img src="' + esc(src) + '" alt="' + esc(alt || '') + '" loading="lazy" decoding="async">' : ''; }
  var DOG_LINE = 'Their bowls. Their name. Cut to order.';

  /* ---------- 1. phone menu ---------- */
  function setCount(n){
    Array.prototype.forEach.call(document.querySelectorAll('[data-agmn-count]'), function(b){ b.textContent = n; b.hidden = !n; });
  }
  function refreshCount(){
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); }).then(function(c){ setCount(c.item_count || 0); }).catch(function(){});
  }
  function buildDrawer(){
    var nc = document.querySelector('#menu-drawer .menu-drawer__navigation-container');
    if(!nc || nc.querySelector('.agmn-top')) return;
    var top = document.createElement('div'); top.className = 'agmn-top';
    var tiles = studios.concat(D.ready && D.ready.url ? [D.ready] : []);
    top.innerHTML =
      '<form class="agmn-search" action="' + esc(D.search || '/search') + '" method="get" role="search">' +
        '<span class="agmn-search-i">' + ico('search') + '</span>' +
        '<input type="search" name="q" placeholder="Search pads, rulers, boat brands" aria-label="Search the store" autocomplete="off">' +
        '<input type="hidden" name="options[prefix]" value="last">' +
      '</form>' +
      (dog ? '<a class="agmn-new" href="' + esc(dog.url) + '"><span class="agmn-new-img">' + img(dog.img, dog.name) + '</span>' +
        '<span class="agmn-new-b"><span class="agmn-badge">New Arrival</span><span class="agmn-new-t">' + esc(dog.name) + '</span>' +
        '<span class="agmn-new-s">' + DOG_LINE + '</span><span class="agmn-go">Design yours ' + ico('arrow') + '</span></span></a>' : '') +
      '<p class="agmn-k">Design Studios</p>' +
      '<div class="agmn-tiles">' + tiles.map(function(t, i){
        return '<a class="agmn-tile" href="' + esc(t.url) + '" style="--i:' + i + '"><span class="agmn-tile-img">' + img(t.img, t.name) + '</span><span class="agmn-tile-n">' + esc(t.name) + '</span></a>';
      }).join('') + '</div>' +
      '<p class="agmn-k">Browse</p>';
    nc.insertBefore(top, nc.firstChild);

    var foot = document.createElement('div'); foot.className = 'agmn-foot';
    var n = +D.cart || 0;
    foot.innerHTML =
      '<div class="agmn-actions">' +
        '<a class="agmn-act" href="' + esc(D.cartUrl || '/cart') + '">' + ico('cart') + '<span>Cart</span><b data-agmn-count' + (n ? '' : ' hidden') + '>' + n + '</b></a>' +
        '<a class="agmn-act" href="' + esc(D.account || '/account') + '">' + ico('user') + '<span>Account</span></a>' +
      '</div>' +
      ((D.fb || D.ig) ? '<div class="agmn-social"><span>Follow the builds</span><span class="agmn-social-l">' +
        (D.fb ? '<a href="' + esc(D.fb) + '" target="_blank" rel="noopener" aria-label="AquaGrip on Facebook">' + ico('fb', true) + '</a>' : '') +
        (D.ig ? '<a href="' + esc(D.ig) + '" target="_blank" rel="noopener" aria-label="AquaGrip on Instagram">' + ico('ig') + '</a>' : '') +
      '</span></div>' : '');
    nc.appendChild(foot);

    var det = document.getElementById('Details-menu-drawer-container');
    if(det) det.addEventListener('toggle', function(){ if(det.open) refreshCount(); });
  }

  /* ---------- 2. desktop mega menu ---------- */
  function buildMega(){
    Array.prototype.forEach.call(document.querySelectorAll('details.mega-menu .mega-menu__content'), function(c){
      if(c.querySelector('.agmm-strip')) return;
      /* New Arrival card over the photo slot; it steps aside while you point at links */
      var wrap = c.querySelector('.js-megaMenuImgWrp');
      if(wrap && dog){
        var nw = document.createElement('a'); nw.className = 'agmm-new'; nw.href = dog.url;
        nw.innerHTML = img(dog.img, dog.name) +
          '<span class="agmm-new-b"><span class="agmn-badge">New Arrival</span><span class="agmm-new-t">' + esc(dog.name) + '</span>' +
          '<span class="agmm-new-s">' + DOG_LINE + '</span><span class="agmm-new-go">Design yours ' + ico('arrow') + '</span></span>';
        wrap.appendChild(nw);
        Array.prototype.forEach.call(c.querySelectorAll('.mega-menu__link'), function(a){
          a.addEventListener('mouseenter', function(){ wrap.classList.add('is-pointing'); });
          a.addEventListener('focus', function(){ wrap.classList.add('is-pointing'); });
        });
        c.addEventListener('mouseleave', function(){ wrap.classList.remove('is-pointing'); });
      }
      /* studio photo row */
      var strip = document.createElement('div'); strip.className = 'agmm-strip';
      strip.innerHTML = '<div class="agmm-strip-in page-width"><p class="agmm-k">Design Studios <span>Build it on screen. We cut it in Prospect, CT.</span></p><div class="agmm-row">' +
        studios.concat(dog ? [dog] : []).map(function(t, i){
          var isNew = dog && t === dog;
          return '<a class="agmm-tile" href="' + esc(t.url) + '" style="--i:' + i + '"><span class="agmm-tile-img">' + img(t.img, t.name) + (isNew ? '<em>New</em>' : '') + '</span>' +
            '<span class="agmm-tile-b"><span class="agmm-tile-n">' + esc(t.name) + '</span><span class="agmm-tile-go">Design ' + ico('arrow') + '</span></span></a>';
        }).join('') + '</div></div>';
      c.appendChild(strip);
    });
  }

  function init(){ buildDrawer(); buildMega(); }
  /* after ag-nautical.js has built the mega menu's photo caption */
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(init, 0); });
  else setTimeout(init, 0);
})();
